module.exports = __webpack_public_path__ + "img/behance.1ae4d640.svg";